import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const DriversSettings = () => {
  return (
    <SettingsCard title="Conductores">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default DriversSettings;